import { Card, CardContent } from '@/components/ui/card';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    quote: 'Melhorou muito nossa qualidade de informações dentro do nosso Instagram',
    author: 'Lubas&Sales',
    role: 'Cliente VitaCode',
  },
  {
    quote: 'Excelente atendimento e resultados que superaram nossas expectativas',
    author: 'Empresa Parceira',
    role: 'Desenvolvimento Web',
  },
  {
    quote: 'A gestão de mídias transformou nossa presença digital completamente',
    author: 'Influencer Digital',
    role: 'Gestão de Conteúdo',
  },
];

export function TestimonialsSection() {
  return (
    <section className="py-20 md:py-28 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-16">
          O Que Nossos Clientes Dizem
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-2 hover:border-vitapink transition-colors">
              <CardContent className="p-8">
                <Quote className="w-10 h-10 text-vitapink mb-6" />
                <p className="text-gray-600 text-lg mb-6 italic leading-relaxed">
                  "{testimonial.quote}"
                </p>
                <div className="border-t pt-4">
                  <p className="font-bold text-gray-900">{testimonial.author}</p>
                  <p className="text-sm text-gray-500">{testimonial.role}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
